import api from './index.js'

export function getNoticeList(params) {
  return api.get('/api/v1/notices', { params })
}

export function getNoticeDetail(boardCode) {
  return api.get(`/api/v1/notices/${encodeURIComponent(boardCode)}`)
}

export function createNotice(body) {
  return api.post('/api/v1/notices', body)
}

export function updateNotice(boardCode, body) {
  return api.put(`/api/v1/notices/${encodeURIComponent(boardCode)}`, body)
}

export function deleteNotice(boardCode) {
  return api.delete(`/api/v1/notices/${encodeURIComponent(boardCode)}`)
}
